import type { OrganizationBrandResponse } from "~/types/organizations";
import {
  SCHOOL_LOGIN_FAVICON,
  SCHOOL_LOGIN_PENDING_TITLE,
} from "~/utils/loginHost";

export const schoolBrowserFavicon = (
  brand:
    | Pick<OrganizationBrandResponse, "logo_url" | "favicon_url">
    | null
    | undefined,
): string => brand?.favicon_url || brand?.logo_url || SCHOOL_LOGIN_FAVICON;

/** Page titles are unbranded here; preserve user-authored text verbatim. */
export const schoolBrowserTitle = (
  pageTitle: string | undefined,
  schoolName: string | undefined,
): string => {
  if (!schoolName) return SCHOOL_LOGIN_PENDING_TITLE;
  if (
    !pageTitle ||
    pageTitle === schoolName ||
    pageTitle === SCHOOL_LOGIN_PENDING_TITLE
  )
    return schoolName;
  return `${pageTitle} | ${schoolName}`;
};
